export interface PushServiceConfig {
    host: string;
    service: string;
    client: string;
}
